import { Box, Chip } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import {
  NODE_CATEGORY_COLORS,
  NODE_CATEGORY_LABELS,
  type NodeCategory,
} from './nodeCategory';

const CATEGORIES: NodeCategory[] = ['backend', 'frontend', 'resource'];

/**
 * Legend for the colors CategoryColorNode assigns to catalog graph nodes.
 */
export function CategoryLegend() {
  const theme = useTheme();
  const mode = theme.palette.type === 'dark' ? 'dark' : 'light';

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      style={{ gap: 8, marginBottom: 16 }}
    >
      {CATEGORIES.map(category => (
        <Chip
          key={category}
          size="small"
          label={NODE_CATEGORY_LABELS[category]}
          style={{
            backgroundColor: NODE_CATEGORY_COLORS[category][mode],
            color: '#fff',
            fontWeight: 600,
          }}
        />
      ))}
    </Box>
  );
}
